import styled from 'styled-components';
import { Table } from 'ui';

export const CenteredCell = styled.div`
  text-align: center;
`;

export const StyledFilters = styled.div`
  display: flex;
  gap: 20px;
  align-items: end;

  .products-filter {
    min-width: 150px;
  }

  .filter-input {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }

  .open-view-checkbox {
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledApplicationsTable = styled(Table)`
  && {
    tbody tr:nth-child(2n) > td {
      background-color: transparent;
    }

    tbody tr.category-row > td {
      background-color: transparent;
    }

    tbody tr.supplier-row > td {
      background-color: ${({ theme }) => theme.tableSecondRowColor};
    }
  }

  .view-button {
    white-space: normal;
    word-wrap: break-word;
    padding: 5px 20px;
    height: auto;
    border-radius: 24px;
    color: ${({ theme }) => theme.colorButtonText};
  }

  .contract-checkbox {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${({ theme }) => theme.badgeBackground};

      &:after {
        border-color: ${({ theme }) => theme.white};
      }
    }
  }

  .contract-changes-button {
    color: ${({ theme }) => theme.red};
    text-decoration: underline;
    padding: 0;
    height: auto;
    border: none;
    box-shadow: none;

    &:hover {
      color: ${({ theme }) => theme.red};
      text-decoration: underline;
    }

    .text {
      text-decoration: underline;
    }
  }

  .ant-table-tbody > tr > td:last-child,
  .ant-table-thead > tr > th:last-child {
    padding: 15px 5px;
  }

  .ant-table-row-level-1 {
    .indent-level-1 {
      padding: 0 !important;
    }

    button {
    }
  }

  .product-name::before {
    content: '•';
    padding: 0 10px;
  }

  .status-tag.status {
    padding: 3px 10px;
    line-height: 18px;
    border-radius: 36px;
    font-size: 12px;
    color: ${({ theme }) => theme.white};
    border: none;
    margin: 0;
  }

  .status-tag.selected {
    background-color: ${({ theme }) => theme.statusHasOffers};
  }

  .status-tag.accepted {
    background-color: ${({ theme }) => theme.statusCompleted};
  }

  .status-tag.rejected {
    background-color: ${({ theme }) => theme.statusUnsuccessful};
  }

  .status-tag.withdrawn {
    background-color: ${({ theme }) => theme.statusCancelled};
  }

  .action-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .status-tag {
    text-transform: capitalize;
  }

  .best-value-highlight {
    border: 1px solid ${({ theme }) => theme.darkGrayishBlue};
    border-radius: 5px;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

export const StyledMobileApplicationCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .application-card {
    border: 1px solid ${({ theme }) => theme.border};
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .card-header {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }

  .card-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
  }

  .card-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;

    &.end {
      align-items: flex-end;
      text-align: end;
    }
  }

  .card-label {
    color: ${({ theme }) => theme.stepInactiveColor};
  }

  .card-value {
    color: ${({ theme }) => theme.darkGrayishBlue};
  }

  .single-producer-card > .card-row {
    padding: 6px 0;
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }

  .single-producer-card > .card-row:has(+ .card-products) {
    border-bottom: none;
  }

  .single-producer-card .card-products {
    gap: 8px;
  }

  .single-producer-card .product-item {
    padding: 10px;
    background-color: ${({ theme }) => theme.filterBackground};

    .product-name {
      border-bottom: 1px solid ${({ theme }) => theme.border};
      padding-bottom: 4px;
    }
  }

  .single-producer-card .view-application-btn {
    margin-top: 10px;
  }

  .card-products {
    display: flex;
    flex-direction: column;
  }

  .product-item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .product-name {
      font-weight: 600;
      color: ${({ theme }) => theme.darkGrayishBlue};
    }
  }

  .view-application-btn {
    width: 100%;
    border-radius: 24px;
    border: 1px solid ${({ theme }) => theme.darkGrayishBlue};
    color: ${({ theme }) => theme.colorButtonText};
    background: transparent;
    margin-top: 4px;

    &:hover {
      border-color: ${({ theme }) => theme.darkGrayishBlue};
      color: ${({ theme }) => theme.colorButtonText};
      opacity: 0.8;
    }
  }

  .contract-changes-button {
    color: ${({ theme }) => theme.red};
    text-decoration: underline;
    padding: 0;
    height: auto;
    justify-content: flex-start;
    gap: 13px;
    align-items: center;

    img {
      width: 15px;
      height: 15px;
    }
  }

  .product-header-row {
    padding-bottom: 0;
  }

  .product-name-row {
    padding-bottom: 8px;

    .product-name {
      font-weight: 600;
    }
  }

  .farm-offer-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 10px;
    margin-bottom: 8px;
    background-color: ${({ theme }) => theme.filterBackground};

    &:last-child {
      margin-bottom: 0;
    }

    .farm-name-row,
    .card-row {
      padding-bottom: 6px;
      border-bottom: 1px solid ${({ theme }) => theme.border};
    }

    .card-row:last-of-type {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .farm-name-row {
    display: flex;
    align-items: center;
    gap: 8px;

    .farm-name {
      font-weight: 600;
    }
  }
`;
